module.exports = __webpack_public_path__ + "img/vr3.572c6d18.jpg";